import { cn } from "@/lib/utils"
import { Label } from "@/components/ui/label"

/**
 * Displays the primary label or heading for your input.
 */
export function InputDescription({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <Label className={cn("text-sm font-medium text-foreground", className)}>
      {children}
    </Label>
  )
}
